export const normalizePath = (path?: string | null) =>
  path ? path.replace(/\/$/, '') : '';
